import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile,map } from "rxjs/operators";
import { Router,ActivatedRoute,ParamMap,NavigationExtras } from "@angular/router";
import { format,parse,differenceInDays } from 'date-fns';
import addDays from 'date-fns/addDays';
import * as c3 from 'c3';

import {
    FvmsExcelService
    ,FvmsApiDtgDriveSafeEcoService
} from "src/app/shared/service";
import {
    FvmsCommonService
    ,FvmsUtilService
    ,PagingInfo
    ,FvmsApiDtgReportCarService
    ,FilterDateDiff
    ,FilterSecToTime
    ,FilterDist
} from "src/app/shared";

@Component({
    templateUrl: './dtg.report.car.detail.component.html'
    ,styleUrls: ["./dtg.report.car.detail.component.scss"]
    ,providers:[FilterDateDiff,FilterSecToTime,FilterDist]
})
export class DtgReportCarDetailComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    subtitle: string;
    companyInfo:any;
    dtgUnitId:string;
    pagingInfo:PagingInfo = new PagingInfo();
    excelPagingInfo:PagingInfo = new PagingInfo();
    listItem:any[]=[];
    listSummary = {
        dtgRegDtDurationSum:0
        ,dtgIdleSecSum:0
        ,dtgDistAccumulSum:0
        ,dtgRegDtDurationAvg:0
        ,dtgIdleSecAvg:0
        ,dtgDistAccumulAvg:0
        ,diffDay:1
        ,driveDtMin:null
        ,driveDtMax:null
    };
    listChart:any[];

    chart01:any;
    chart02:any;
    chart03:any;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService: FvmsCommonService
        ,private fvmsUtilService: FvmsUtilService
        ,private activatedRoute: ActivatedRoute
        ,private fvmsApiDtgReportCarService:FvmsApiDtgReportCarService
        ,private filterDateDiff:FilterDateDiff
        ,private fvmsExcelService:FvmsExcelService
        ,private filterSecToTime:FilterSecToTime
        ,private filterDist:FilterDist
        ,private router: Router
        ,private fvmsApiDtgDriveSafeEcoService:FvmsApiDtgDriveSafeEcoService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.dtgUnitId = this.activatedRoute.snapshot.params.dtgUnitId;
        this.excelPagingInfo.pageSize = 60*60*24;
    }

    ngOnInit() {
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                if(companyInfo && this.companyInfo){
                    if(this.companyInfo.companyId !== companyInfo.companyId){
                        //회사가 바뀌면 차량 목록이 다르므로 메인 페이지로 이동해야 함
                        let tmpParam = {
                            runtime:new Date().getTime()
                        };
                        let navigationExtras:NavigationExtras = {
                            queryParams:tmpParam
                        };
                        this.router.navigate(["/dtg/report/car/all"],navigationExtras);
                    }
                }else{
                    this.companyInfo = companyInfo;
                }
                this.reloadListItem();
                // this.reloadListSummary();
                this.reloadChart2();
            });

        this.fvmsCommonService.subscribeDateInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(dateInfo => {
                this.reloadListItem();
                // this.reloadListSummary();
                this.reloadChart2();
            });

        this.reloadListItem();
        // this.reloadListSummary();
        this.reloadChart2();

    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {}

    getSearchInfo(){
        this.listSummary.diffDay = this.fvmsCommonService.getDayDiff();
        return {
            companyId:this.companyInfo?.companyId || 0
            ,dtgUnitId:this.dtgUnitId
            ,searchDateFrom:this.fvmsCommonService.getDateFromIsoReserve()
            ,searchDateTo:this.fvmsCommonService.getDateToIsoReserve()
        };
    }

    reloadListItem(){
        this.fvmsApiDtgReportCarService.getListReportCarDetailTrip(this.getSearchInfo(),this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    // console.log("reloadListItem",apiResponse);
                    this.listItem = [];
                    if(apiResponse.resultValue){
                        this.listItem = apiResponse.resultValue;
                        this.pagingInfo = apiResponse.pagingInfo;
                        if(this.listItem){
                            let tmpItem = this.listItem[0];
                            let title = `${tmpItem.dtgCarNo} 의 운행일지`;
                            // console.log("reloadListItem",title);
                            let routeData = this.activatedRoute.snapshot.data;
                            routeData.title = title;
                        }
                    }
                }
            });
    }

    reloadChart2(){
        let searchInfo = {
            companyId:this.companyInfo?.companyId || 0
            ,dtgUnitId:this.dtgUnitId
            ,searchDateFrom:this.fvmsCommonService.getDateFromIsoReserve()
            ,searchDateTo:this.fvmsCommonService.getDateToIsoReserve()
            ,dtgGroupByRegDtYy:"Y"//년도별 동시운행차량수
            ,dtgGroupByRegDtMm:"Y"//월별 동시운행차량수
            ,dtgGroupByRegDtDd:"Y"//일별 동시운행차량수
        };
        let pagingInfoSum = new PagingInfo();
        pagingInfoSum.pageSize = 999;
        this.fvmsApiDtgDriveSafeEcoService.getListReportSafeDriving(searchInfo,pagingInfoSum)
        // this.fvmsApiDtgReportCarService.getListReportCarChart(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                this.listSummary.dtgDistAccumulSum = 0;
                this.listSummary.dtgRegDtDurationSum = 0;
                this.listSummary.dtgIdleSecSum = 0;
                this.listSummary.driveDtMin;
                this.listSummary.driveDtMax;
                this.listSummary.diffDay = 1;

                if(apiResponse.resultStatus === "ok"){
                    // console.log("reloadChart2",apiResponse);
                    if(apiResponse.resultValue){
                        this.initChart01();
                        this.initChart02();
                        this.initChart03();
                        this.listChart = apiResponse.resultValue;
                        let size = this.listChart.length;

                        for(let a=0;a<size;a++){
                            let item = this.listChart[a];
                            if(!this.listSummary.driveDtMin){
                                this.listSummary.driveDtMin = parse(item.dtgRegDt,'yyyy-MM-dd',new Date());
                                this.listSummary.driveDtMin.setHours(0);
                                this.listSummary.driveDtMin.setMinutes(0);
                                this.listSummary.driveDtMin.setSeconds(0);
                                this.listSummary.driveDtMin.setMilliseconds(0);
                            }
                            if(!this.listSummary.driveDtMax){
                                this.listSummary.driveDtMax = parse(item.dtgRegDt,'yyyy-MM-dd',new Date());
                                this.listSummary.driveDtMax.setHours(0);
                                this.listSummary.driveDtMax.setMinutes(0);
                                this.listSummary.driveDtMax.setSeconds(0);
                                this.listSummary.driveDtMax.setMilliseconds(0);
                            }
                            // console.log("curdt",item.dtgRegDt);
                            let currDriveDt = parse(item.dtgRegDt,'yyyy-MM-dd',new Date());
                            currDriveDt.setHours(0);
                            currDriveDt.setMinutes(0);
                            currDriveDt.setSeconds(0);
                            currDriveDt.setMilliseconds(0);

                            if(differenceInDays(currDriveDt,this.listSummary.driveDtMax) >= 0){
                                this.listSummary.driveDtMax = currDriveDt;
                            }
                            if(differenceInDays(this.listSummary.driveDtMin,currDriveDt) >= 0){
                                this.listSummary.driveDtMin = currDriveDt;
                            }

                            this.listSummary.dtgDistAccumulSum += parseInt(item.dtgDistAccumul);
                            this.listSummary.dtgRegDtDurationSum += parseInt(item.dtgRegDtDuration);
                            this.listSummary.dtgIdleSecSum += parseInt(item.durRule101);
                        }
                        this.listSummary.diffDay = differenceInDays(this.listSummary.driveDtMax,this.listSummary.driveDtMin) + 1;
                        // console.log("avg",this.listSummary.diffDay,this.listSummary.driveDtMax,this.listSummary.driveDtMin);

                        this.listSummary.dtgDistAccumulAvg = this.listSummary.dtgDistAccumulSum / this.listSummary.diffDay;
                        this.listSummary.dtgRegDtDurationAvg = Math.round(this.listSummary.dtgRegDtDurationSum / this.listSummary.diffDay);
                        this.listSummary.dtgIdleSecAvg =  Math.round(this.listSummary.dtgIdleSecSum / this.listSummary.diffDay);

                        for(let a=0;a<size;a++){
                            let item = this.listChart[a];
                            item.dtgRegDtDurationAvg = this.listSummary.dtgRegDtDurationAvg;
                            item.dtgDistAccumulAvg = this.listSummary.dtgDistAccumulAvg;
                            item.dtgIdleSecAvg = this.listSummary.dtgIdleSecAvg;
                        }

                        this.chart01.load({
                            json:this.listChart
                            ,unload:true
                            ,keys:{
                                x:"dtgRegDt"
                                ,value:[
                                    "dtgRegDtDuration"
                                    ,"dtgRegDtDurationAvg"
                                ]
                            }
                        });
                        this.chart02.load({
                            json:this.listChart
                            ,unload:true
                            ,keys:{
                                x:"dtgRegDt"
                                ,value:[
                                    "durRule101"
                                    ,"dtgIdleSecAvg"
                                ]
                            }
                        });
                        this.chart03.load({
                            json:this.listChart
                            ,unload:true
                            ,keys:{
                                x:"dtgRegDt"
                                ,value:[
                                    "dtgDistAccumul"
                                    ,"dtgDistAccumulAvg"
                                ]
                            }
                        });
                    }
                }
            });
    }

    initChart01(){
        let self = this;
        this.chart01 = c3.generate({
            bindto: '#chart-01'
            ,data: {
                json:[]
                ,keys:{
                    x:"dtgRegDt"
                    ,value:[
                        "dtgRegDtDuration"
                        ,"dtgRegDtDurationAvg"
                    ]
                }
                ,types:{
                    dtgRegDtDuration:"bar"
                    ,dtgRegDtDurationAvg:"line"
                }
                ,names:{
                    dtgRegDtDuration:"운행시간"
                    ,dtgRegDtDurationAvg:"일평균운행시간"
                }
                ,onclick:(d,el) => {
                    console.log("click",d.id,d.value);
                }
                ,onmouseover:(d) => {
                }
            }
            ,axis:{
                x:{
                    type:"category"
                    ,show: false
                }
                ,y:{
                    tick: {
                        format: function(y){
                            return self.filterSecToTime.transform(y,"HH:mm:ss");
                        }
                    }
                }
            }
            ,legend: {
                hide: true
            }
        });
    }

    initChart02(){
        let self = this;
        this.chart02 = c3.generate({
            bindto: '#chart-02'
            ,data: {
                json:[]
                ,keys:{
                    x:"dtgRegDt"
                    ,value:[
                        "durRule101"
                        ,"dtgIdleSecAvg"
                    ]
                }
                ,types:{
                    durRule101:"bar"
                    ,dtgIdleSecAvg:"line"
                }
                ,names:{
                    durRule101:"공회전시간"
                    ,dtgIdleSecAvg:"일평균공회전시간"
                }
                ,onclick:(d,el) => {
                    console.log("click",d.id,d.value);
                }
                ,onmouseover:(d) => {
                }
            }
            ,axis:{
                x:{
                    type:"category"
                    ,show: false
                }
                ,y:{
                    tick: {
                        format: function(y){
                            return self.filterSecToTime.transform(y,"HH:mm:ss");
                        }
                    }
                }
            }
            ,legend: {
                hide: true
            }
        });
    }

    initChart03(){
        let self = this;
        this.chart03 = c3.generate({
            bindto: '#chart-03'
            ,data: {
                json:[]
                ,keys:{
                    x:"dtgRegDt"
                    ,value:[
                        "dtgDistAccumul"
                        ,"dtgDistAccumulAvg"
                    ]
                }
                ,types:{
                    dtgDistAccumul:"bar"
                    ,dtgDistAccumulAvg:"line"
                }
                ,names:{
                    dtgDistAccumul:"운행거리"
                    ,dtgDistAccumulAvg:"일평균운행거리"
                }
                ,onclick:(d,el) => {
                    console.log("click",d.id,d.value);
                }
                ,onmouseover:(d) => {
                }
            }
            ,axis:{
                x:{
                    type:"category"
                    ,show: false
                }
                ,y:{
                    tick: {
                        format: function(y){
                            let val = self.filterDist.transform(y);
                            return `${val.toFixed(1)} km`;
                        }
                    }
                }
            }
            ,legend: {
                hide: true
            }
        });
    }

    callbackClickPageNumber(selectedPage:number){
        this.pagingInfo.curPage = selectedPage;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.reloadListItem();
    }

    excelDownload(){
        this.fvmsCommonService.setIsLoading(true);
        this.fvmsApiDtgReportCarService.getListReportCarDetailTrip(this.getSearchInfo(),this.excelPagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.fvmsExcelService.excelDownload(this.convertExcelJson(apiResponse.resultValue),"car_driving_log_per_trip");
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    convertExcelJson(dataList:any[]){
        let resultList = [];
        let cnt = dataList.length;
        dataList.map((v,i) => {
            console.log(v);
            resultList.push({
                "No":cnt-i
                ,"시작":v.dtgRegDtFrom
                ,"종료":v.dtgRegDtTo
                ,"운행시간":this.filterSecToTime.transform(v.dtgRegDtDuration,"HH:mm:ss")
                ,"운행거리(km)": this.filterDist.transform(Number(v.dtgDistAccumulTo - v.dtgDistAccumulFrom))
                ,"운전자ID":v?.userId || "미지정"
                ,"운전자명":v?.userNm || "미지정"
                ,"연료소모량(L)":this.filterDist.transform(Number(v.dtgOilUseAccumulTo - v.dtgOilUseAccumulFrom).toFixed(3))
                ,"종료시온도1(°C)":v.dtgTemper1
                ,"종료시온도2(°C)":v.dtgTemper2
                ,"위치(종료)":v?.dtgGpsAddr || ""
            })
        });
        return resultList;
    }


}
